// extracted by mini-css-extract-plugin
export var SearchWrapper = "Table-module--SearchWrapper--3dzhR";
export var SearchInput = "Table-module--SearchInput--1DixR";
export var SearchIcon = "Table-module--SearchIcon--1iuca";